import {createAction} from '@reduxjs/toolkit';

export const notify = createAction('NOTIFY');

export const dismissNotification = createAction('DISMISS_NOTIFICATION');
